import { action  } from "satcheljs";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";

const clearScheduleDataInView = action(
    'CLEAR_SCHEDULE_DATA_IN_VIEW',
    (
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore,
        clearIsViewStatePopulated: boolean = true
    ) => ({
            viewState,
            clearIsViewStatePopulated
    })
);

export default clearScheduleDataInView;